import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { TESTIMONIAL } from "@/data/content";

export default function Testimonial() {
  return (
    <section data-testid="testimonial-section" className="relative overflow-hidden border-t border-white/5 bg-[#0A0A0A] py-24 lg:py-32">
      <div className="absolute right-0 top-0 h-80 w-80 rounded-full bg-electric/10 blur-3xl" aria-hidden="true" />
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <SectionHeading label="Testimonial" title="Words from" accent="the mentor" testId="testimonial-heading" />
        <Reveal>
          <figure className="relative rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm sm:p-12" data-testid="testimonial-card">
            <Quote size={48} className="absolute -top-6 left-8 rounded-xl border border-electric/40 bg-[#050505] p-2.5 text-electric" aria-hidden="true" />
            <blockquote className="space-y-5 text-base leading-relaxed text-neutral-300 sm:text-lg">
              {TESTIMONIAL.paragraphs.map((p) => (
                <p key={p.slice(0, 24)}>{p}</p>
              ))}
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-electric font-display text-lg font-semibold text-[#050505]" aria-hidden="true">
                AW
              </div>
              <div>
                <p className="font-display text-lg font-semibold text-neutral-100" data-testid="testimonial-author">{TESTIMONIAL.author}</p>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">{TESTIMONIAL.title}</p>
              </div>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
